/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// use `yarn generate:graphql to regenerate


      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AbsenceRecordOrNfsError": [
      "AbsenceRecord",
      "NfsError"
    ],
    "AbstractDrawer": [
      "AdditionalCostsDrawer",
      "BookDeskDrawer",
      "BookParkingDrawer",
      "CopyrightsDrawer",
      "EditAdditionalDataDrawer",
      "EditAddressDrawer",
      "EditProfileDetailsDrawer",
      "EditSkillsAndCertificatesDrawer",
      "EditSocialMediaHandlesDrawer",
      "InvoicesDrawer",
      "TimeReportPreferencesDrawer"
    ],
    "AnnualLeaveSummaryOrNfsError": [
      "AnnualLeaveSummary",
      "NfsError"
    ],
    "Approval": [
      "Approved",
      "NotRequired",
      "PendingApproval"
    ],
    "BenefitAdditionalPeople": [
      "BenefitAdditionalAdults",
      "BenefitAdditionalFamily",
      "BenefitAdditionalKids"
    ],
    "BenefitCommon": [
      "Benefit",
      "SubBenefit"
    ],
    "Bonus": [
      "AppreciationBonus",
      "BusinessTravelBonus",
      "ClientReferralBonus",
      "ConferenceBonus",
      "CostRechargeBonus",
      "EmployeeReferralBonus",
      "LanguageLearningBonus",
      "OtherBonus",
      "RemoteWorkEquipmentBonus",
      "SalesCommissionsBonus",
      "SeverancePayBonus",
      "ShareholderDividendBonus",
      "TrainingPackageBonus",
      "TrainingPackageExternalDeductionValue"
    ],
    "BonusResponseOrNfsError": [
      "BonusResponse",
      "NfsError"
    ],
    "BooleanResponseOrNfsError": [
      "BooleanResponse",
      "NfsError"
    ],
    "CertificateOrNfsError": [
      "Certificate",
      "NfsError"
    ],
    "ClosedEndLocalDateRangeOrNfsError": [
      "ClosedEndLocalDateRange",
      "NfsError"
    ],
    "Contract": [
      "B2BContract",
      "EmploymentContract",
      "Subcontract"
    ],
    "ContractResponseOrNfsError": [
      "ContractResponse",
      "NfsError"
    ],
    "ContractSalaryDetails": [
      "B2BContractSalaryDetails",
      "EmploymentContractSalaryDetails"
    ],
    "ContractSalaryDetailsResponseOrNfsError": [
      "ContractSalaryDetailsResponse",
      "NfsError"
    ],
    "DaysBalanceOrNfsError": [
      "DaysBalance",
      "NfsError"
    ],
    "DownloadableFileUrlOrNfsError": [
      "DownloadableFileUrl",
      "NfsError"
    ],
    "Highlight": [],
    "IncomeRow": [
      "DailyIncomeRow",
      "HourlyIncomeRow",
      "MonthlyIncomeRow"
    ],
    "InvoiceDetailsOrNfsError": [
      "InvoiceDetails",
      "NfsError"
    ],
    "ListOfAbsenceRecordResponseOrNfsError": [
      "ListOfAbsenceRecordResponse",
      "NfsError"
    ],
    "ListOfAssignedProjectResponseOrNfsError": [
      "ListOfAssignedProjectResponse",
      "NfsError"
    ],
    "ListOfContractSalaryDetailsResponseOrNfsError": [
      "ListOfContractSalaryDetailsResponse",
      "NfsError"
    ],
    "ListOfDeskAssignmentResponseOrNfsError": [
      "ListOfDeskAssignmentResponse",
      "NfsError"
    ],
    "ListOfKVWorkTagIdMinutesResponseOrNfsError": [
      "ListOfKVWorkTagIdMinutesResponse",
      "NfsError"
    ],
    "ListOfOnCallRecordResponseOrNfsError": [
      "ListOfOnCallRecordResponse",
      "NfsError"
    ],
    "ListOfProjectIdResponseOrNfsError": [
      "ListOfProjectIdResponse",
      "NfsError"
    ],
    "ListOfProjectTimeReportsResponseOrNfsError": [
      "ListOfProjectTimeReportsResponse",
      "NfsError"
    ],
    "ListOfReservableOfficeResponseOrNfsError": [
      "ListOfReservableOfficeResponse",
      "NfsError"
    ],
    "ListOfReservationRequestResponseOrNfsError": [
      "ListOfReservationRequestResponse",
      "NfsError"
    ],
    "ListOfTimeReportValidationResponseOrNfsError": [
      "ListOfTimeReportValidationResponse",
      "NfsError"
    ],
    "ListOfWorkRecordResponseOrNfsError": [
      "ListOfWorkRecordResponse",
      "NfsError"
    ],
    "OfficeAvailabilityOrNfsError": [
      "NfsError",
      "OfficeAvailability"
    ],
    "OfficeReservationSettingsOrNfsError": [
      "NfsError",
      "OfficeReservationSettings"
    ],
    "OnCallMultipliersOrNfsError": [
      "NfsError",
      "OnCallMultipliers"
    ],
    "OnCallRecordOrNfsError": [
      "NfsError",
      "OnCallRecord"
    ],
    "ReservationRequestOrNfsError": [
      "NfsError",
      "ReservationRequest"
    ],
    "SalaryState": [
      "IncompleteData",
      "PaymentDisbursed",
      "Ready"
    ],
    "TimeReportOrNfsError": [
      "NfsError",
      "TimeReport"
    ],
    "TimeReportStats": [
      "B2BTimeReportStats",
      "EmploymentTimeReportStats"
    ],
    "TimeReportValidation": [
      "IncompleteEntries",
      "MissingEntries",
      "NegativeFlexTimeBalance"
    ],
    "TrainingBudgetSummaryOrNfsError": [
      "NfsError",
      "TrainingBudgetSummary"
    ],
    "UnitResponseOrNfsError": [
      "NfsError",
      "UnitResponse"
    ],
    "UserError": [
      "ActiveReportingRangeError",
      "AggregatedValidationErrors",
      "DuplicatedEntityError",
      "EmptyRequestInputError",
      "EntitiesNotFoundError",
      "EntityNotFoundError",
      "EntityVersionMismatched",
      "ForeignKeyConstraintError",
      "IllegalPositionRemovalError",
      "IncompleteArgumentError",
      "IncompleteArgumentsError",
      "InternalNfsError",
      "InvalidApiTokenError",
      "InvalidArgumentsError",
      "InvalidCompanyTypeError",
      "InvalidContentTypeError",
      "InvalidCursorError",
      "InvalidEmailAddress",
      "InvalidStateError",
      "InvoiceAlreadyAcceptedError",
      "InvoiceImportedFromSaldeoError",
      "LeaveEntitlementExceededError",
      "MissingFileMetadataError",
      "NBPBaseCurrencyError",
      "NoParkingSpotAvailableError",
      "OperationAlreadyInProgressError",
      "OperationNotAvailableError",
      "OtherInvalidRequestError",
      "PaymentCouldNotBeChangedError",
      "PositionInactiveError",
      "RaiseNoLongerDueError",
      "ReservationNotPendingError",
      "ReservationRequestStateError",
      "ResourceAlreadyReservedError",
      "TimeBasedActivityOverlapError",
      "TimeBasedEffectiveFromInPastError",
      "TimeReportOverlapError",
      "TimeReportRecordApprovalNotInPendingStateError",
      "UnauthorizedOperationError",
      "UnknownContentTypeError",
      "UserFacingAuthzError",
      "ValidationError"
    ],
    "UserOrNfsError": [
      "NfsError",
      "User"
    ],
    "VatType": [
      "VatApplied",
      "VatNotApplied"
    ],
    "WorkRecordOrNfsError": [
      "NfsError",
      "WorkRecord"
    ],
    "WorkTransferProtocolOrNfsError": [
      "NfsError",
      "WorkTransferProtocol"
    ],
    "WorkTransferProtocolPayload": [
      "File",
      "NoWorkToBeTransferedThisMonth"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AbsenceRecordOrNfsError": [
      "AbsenceRecord",
      "NfsError"
    ],
    "AbstractDrawer": [
      "AdditionalCostsDrawer",
      "BookDeskDrawer",
      "BookParkingDrawer",
      "CopyrightsDrawer",
      "EditAdditionalDataDrawer",
      "EditAddressDrawer",
      "EditProfileDetailsDrawer",
      "EditSkillsAndCertificatesDrawer",
      "EditSocialMediaHandlesDrawer",
      "InvoicesDrawer",
      "TimeReportPreferencesDrawer"
    ],
    "AnnualLeaveSummaryOrNfsError": [
      "AnnualLeaveSummary",
      "NfsError"
    ],
    "Approval": [
      "Approved",
      "NotRequired",
      "PendingApproval"
    ],
    "BenefitAdditionalPeople": [
      "BenefitAdditionalAdults",
      "BenefitAdditionalFamily",
      "BenefitAdditionalKids"
    ],
    "BenefitCommon": [
      "Benefit",
      "SubBenefit"
    ],
    "Bonus": [
      "AppreciationBonus",
      "BusinessTravelBonus",
      "ClientReferralBonus",
      "ConferenceBonus",
      "CostRechargeBonus",
      "EmployeeReferralBonus",
      "LanguageLearningBonus",
      "OtherBonus",
      "RemoteWorkEquipmentBonus",
      "SalesCommissionsBonus",
      "SeverancePayBonus",
      "ShareholderDividendBonus",
      "TrainingPackageBonus",
      "TrainingPackageExternalDeductionValue"
    ],
    "BonusResponseOrNfsError": [
      "BonusResponse",
      "NfsError"
    ],
    "BooleanResponseOrNfsError": [
      "BooleanResponse",
      "NfsError"
    ],
    "CertificateOrNfsError": [
      "Certificate",
      "NfsError"
    ],
    "ClosedEndLocalDateRangeOrNfsError": [
      "ClosedEndLocalDateRange",
      "NfsError"
    ],
    "Contract": [
      "B2BContract",
      "EmploymentContract",
      "Subcontract"
    ],
    "ContractResponseOrNfsError": [
      "ContractResponse",
      "NfsError"
    ],
    "ContractSalaryDetails": [
      "B2BContractSalaryDetails",
      "EmploymentContractSalaryDetails"
    ],
    "ContractSalaryDetailsResponseOrNfsError": [
      "ContractSalaryDetailsResponse",
      "NfsError"
    ],
    "DaysBalanceOrNfsError": [
      "DaysBalance",
      "NfsError"
    ],
    "DownloadableFileUrlOrNfsError": [
      "DownloadableFileUrl",
      "NfsError"
    ],
    "Highlight": [],
    "IncomeRow": [
      "DailyIncomeRow",
      "HourlyIncomeRow",
      "MonthlyIncomeRow"
    ],
    "InvoiceDetailsOrNfsError": [
      "InvoiceDetails",
      "NfsError"
    ],
    "ListOfAbsenceRecordResponseOrNfsError": [
      "ListOfAbsenceRecordResponse",
      "NfsError"
    ],
    "ListOfAssignedProjectResponseOrNfsError": [
      "ListOfAssignedProjectResponse",
      "NfsError"
    ],
    "ListOfContractSalaryDetailsResponseOrNfsError": [
      "ListOfContractSalaryDetailsResponse",
      "NfsError"
    ],
    "ListOfDeskAssignmentResponseOrNfsError": [
      "ListOfDeskAssignmentResponse",
      "NfsError"
    ],
    "ListOfKVWorkTagIdMinutesResponseOrNfsError": [
      "ListOfKVWorkTagIdMinutesResponse",
      "NfsError"
    ],
    "ListOfOnCallRecordResponseOrNfsError": [
      "ListOfOnCallRecordResponse",
      "NfsError"
    ],
    "ListOfProjectIdResponseOrNfsError": [
      "ListOfProjectIdResponse",
      "NfsError"
    ],
    "ListOfProjectTimeReportsResponseOrNfsError": [
      "ListOfProjectTimeReportsResponse",
      "NfsError"
    ],
    "ListOfReservableOfficeResponseOrNfsError": [
      "ListOfReservableOfficeResponse",
      "NfsError"
    ],
    "ListOfReservationRequestResponseOrNfsError": [
      "ListOfReservationRequestResponse",
      "NfsError"
    ],
    "ListOfTimeReportValidationResponseOrNfsError": [
      "ListOfTimeReportValidationResponse",
      "NfsError"
    ],
    "ListOfWorkRecordResponseOrNfsError": [
      "ListOfWorkRecordResponse",
      "NfsError"
    ],
    "OfficeAvailabilityOrNfsError": [
      "NfsError",
      "OfficeAvailability"
    ],
    "OfficeReservationSettingsOrNfsError": [
      "NfsError",
      "OfficeReservationSettings"
    ],
    "OnCallMultipliersOrNfsError": [
      "NfsError",
      "OnCallMultipliers"
    ],
    "OnCallRecordOrNfsError": [
      "NfsError",
      "OnCallRecord"
    ],
    "ReservationRequestOrNfsError": [
      "NfsError",
      "ReservationRequest"
    ],
    "SalaryState": [
      "IncompleteData",
      "PaymentDisbursed",
      "Ready"
    ],
    "TimeReportOrNfsError": [
      "NfsError",
      "TimeReport"
    ],
    "TimeReportStats": [
      "B2BTimeReportStats",
      "EmploymentTimeReportStats"
    ],
    "TimeReportValidation": [
      "IncompleteEntries",
      "MissingEntries",
      "NegativeFlexTimeBalance"
    ],
    "TrainingBudgetSummaryOrNfsError": [
      "NfsError",
      "TrainingBudgetSummary"
    ],
    "UnitResponseOrNfsError": [
      "NfsError",
      "UnitResponse"
    ],
    "UserError": [
      "ActiveReportingRangeError",
      "AggregatedValidationErrors",
      "DuplicatedEntityError",
      "EmptyRequestInputError",
      "EntitiesNotFoundError",
      "EntityNotFoundError",
      "EntityVersionMismatched",
      "ForeignKeyConstraintError",
      "IllegalPositionRemovalError",
      "IncompleteArgumentError",
      "IncompleteArgumentsError",
      "InternalNfsError",
      "InvalidApiTokenError",
      "InvalidArgumentsError",
      "InvalidCompanyTypeError",
      "InvalidContentTypeError",
      "InvalidCursorError",
      "InvalidEmailAddress",
      "InvalidStateError",
      "InvoiceAlreadyAcceptedError",
      "InvoiceImportedFromSaldeoError",
      "LeaveEntitlementExceededError",
      "MissingFileMetadataError",
      "NBPBaseCurrencyError",
      "NoParkingSpotAvailableError",
      "OperationAlreadyInProgressError",
      "OperationNotAvailableError",
      "OtherInvalidRequestError",
      "PaymentCouldNotBeChangedError",
      "PositionInactiveError",
      "RaiseNoLongerDueError",
      "ReservationNotPendingError",
      "ReservationRequestStateError",
      "ResourceAlreadyReservedError",
      "TimeBasedActivityOverlapError",
      "TimeBasedEffectiveFromInPastError",
      "TimeReportOverlapError",
      "TimeReportRecordApprovalNotInPendingStateError",
      "UnauthorizedOperationError",
      "UnknownContentTypeError",
      "UserFacingAuthzError",
      "ValidationError"
    ],
    "UserOrNfsError": [
      "NfsError",
      "User"
    ],
    "VatType": [
      "VatApplied",
      "VatNotApplied"
    ],
    "WorkRecordOrNfsError": [
      "NfsError",
      "WorkRecord"
    ],
    "WorkTransferProtocolOrNfsError": [
      "NfsError",
      "WorkTransferProtocol"
    ],
    "WorkTransferProtocolPayload": [
      "File",
      "NoWorkToBeTransferedThisMonth"
    ]
  }
};
      export default result;
    